module.exports = __webpack_public_path__ + "static/media/Role-of-the-Arbitration-2.345b940e.jpg";